import React from 'react';
import { useStaticQuery } from 'gatsby';
import { StyledH4 } from './h4.styled';
var H4 = function H4(_ref) {
    var stringText = _ref.stringText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("342064096"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledH4, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.h4_text_styles.text
    }, stringText);
};
export default H4;
